import { createFileRoute } from "@tanstack/react-router";
import { RevenueAnalyticsPage } from "@/features/revenue-analytics/RevenueAnalyticsPage";

export const Route = createFileRoute("/_app/reports/revenue-analytics")({ component: RevenueAnalyticsPage });
